export default __webpack_public_path__ + "static/media/BrownLLWeb-Bold.0a65f302.woff2";